module.exports = __webpack_public_path__ + "img/yishi5.d1802caa.jpg";